import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'
import TextAreaWithEditorsOptions from 'app/components/TextArea/TextAreaWithEditorsOptions'
import MentionTextArea from 'app/components/MentionTextArea'

import './styles.scss'
const bc = 'text-area'

export class TextArea extends Component {
  renderControl = style => {
    const {
      availableEditorsOptions,
      availableMentionOptions,
      classTextArea,
      meta: { error, touched },
      input,
      placeholder = 'Please write here',
      disabled,
      t,
    } = this.props

    if (availableEditorsOptions) {
      return <TextAreaWithEditorsOptions bc={bc} {...this.props} />
    }

    const controlProps = {
      className: classNames(`${bc}__field`, classTextArea, {
        error: touched && error,
      }),
      id: `input-${input.name}`,
      placeholder: t(placeholder),
      ...input,
      disabled,
    }

    if (availableMentionOptions) {
      return <MentionTextArea {...controlProps} />
    }

    return <textarea {...controlProps} style={style} />
  }

  render() {
    const {
      className,
      input,
      meta: { error, touched },
      label,
      before = true,
      maxCharacters = 255,
      classNumberOfLetters,
      needCharactersLabel = true,
      style,
      charactersCountNormalizer,
    } = this.props

    const userInputLength = (input.value && input.value.length) || 0

    return (
      <div className={classNames(bc, { [className]: !!className })}>
        {label && (
          <label htmlFor={`input-${input.name}`} className={`${bc}__label`}>
            {label}
          </label>
        )}
        <div className={`${bc}__field-wrapper`}>
          {this.renderControl(style)}
          {needCharactersLabel ? (
            <div className={classNames(`${bc}__number-of-letters`, classNumberOfLetters, { error: touched && error })}>
              {charactersCountNormalizer ? charactersCountNormalizer(input.value) : userInputLength}/{maxCharacters}
            </div>
          ) : null}
        </div>
        <>{touched && error && <ErrorLabel before={before && label} htmlFor={`input-${input.name}`} error={error} />}</>
      </div>
    )
  }
}

TextArea.propTypes = {
  disabled: PropTypes.bool,
}

export default withTranslation('common')(TextArea)
